import { CustomAttributeDialog } from './CustomAttributeDialog';
import { CustomAttributes } from './CustomAttributes';

export const CustomAttributesView = () => (
  <div className="@CustomAttributesView contents">
    <CustomAttributes />
    <CustomAttributeDialog />
  </div>
);
